var _rect, _rect2, _rect3, _line, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupinactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 21.5,
    height: 21.5,
    rx: 0.75,
    fill: "#193243"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 21.5,
    height: 21.5,
    rx: 0.75,
    stroke: "white",
    strokeWidth: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 21.5,
    height: 21.5,
    rx: 0.75,
    stroke: "white",
    strokeWidth: 0.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 4.65002,
    x2: 4.65002,
    y2: 22,
    stroke: "white",
    strokeWidth: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1641_4592)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 9,
    transform: "translate(6 7)",
    fill: "#193243"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_1641_4592",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2671 12.1799C17.4726 11.9735 16.6566 11.8631 15.8353 11.8487C15.4864 11.8439 15.2824 12.1943 15.4756 12.4631C15.846 12.9863 16.0608 13.6055 16.0608 14.2583V15.3623C16.0608 15.4247 16.0608 15.4871 16.05 15.5495C16.0178 15.7895 16.2111 15.9959 16.4795 15.9959H19.2924C19.6842 15.9959 20.0009 15.7079 20.0009 15.3575V14.2535C20.0009 13.2935 19.2977 12.4391 18.2671 12.1751"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.8353 11.8487L15.8441 11.3488L15.8422 11.3487L15.8353 11.8487ZM15.4756 12.4631L15.8837 12.1742L15.8816 12.1712L15.4756 12.4631ZM16.05 15.5495L15.5573 15.4647L15.5557 15.4738L15.5545 15.483L16.05 15.5495ZM18.2671 12.1799L18.3928 11.6959C17.5596 11.4795 16.7044 11.3638 15.8441 11.3488L15.8353 11.8487L15.8265 12.3486C16.6089 12.3623 17.3855 12.4675 18.1413 12.6638L18.2671 12.1799ZM15.8353 11.8487L15.8422 11.3487C15.4915 11.3439 15.1837 11.5215 15.0204 11.8011C14.8546 12.0849 14.8529 12.4535 15.0697 12.755L15.4756 12.4631L15.8816 12.1712C15.8893 12.1819 15.8998 12.2043 15.9009 12.2346C15.902 12.2631 15.8943 12.2876 15.8839 12.3055C15.8735 12.3232 15.8604 12.3348 15.8484 12.3415C15.8354 12.3487 15.8269 12.3486 15.8284 12.3486L15.8353 11.8487ZM15.4756 12.4631L15.0676 12.752C15.383 13.1976 15.5608 13.7171 15.5608 14.2583H16.0608H16.5608C16.5608 13.4938 16.309 12.7749 15.8837 12.1742L15.4756 12.4631ZM16.0608 14.2583H15.5608V15.3623H16.0608H16.5608V14.2583H16.0608ZM16.0608 15.3623H15.5608C15.5608 15.4315 15.5596 15.4512 15.5573 15.4647L16.05 15.5495L16.5428 15.6343C16.5619 15.5229 16.5608 15.4179 16.5608 15.3623H16.0608ZM16.05 15.5495L15.5545 15.483C15.4763 16.0653 15.953 16.4959 16.4795 16.4959V15.9959V15.4959C16.4752 15.4959 16.4928 15.4955 16.5138 15.5176C16.5239 15.5281 16.5336 15.5429 16.5399 15.5617C16.5464 15.581 16.5477 15.6002 16.5456 15.616L16.05 15.5495ZM16.4795 15.9959V16.4959H19.2924V15.9959V15.4959H16.4795V15.9959ZM19.2924 15.9959V16.4959C19.9114 16.4959 20.5009 16.0305 20.5009 15.3575H20.0009H19.5009C19.5009 15.3763 19.4933 15.4056 19.4584 15.4371C19.423 15.4691 19.3656 15.4959 19.2924 15.4959V15.9959ZM20.0009 15.3575H20.5009V14.2535H20.0009H19.5009V15.3575H20.0009ZM20.0009 14.2535H20.5009C20.5009 13.0376 19.6152 12.0043 18.3911 11.6907L18.2671 12.1751L18.143 12.6594C18.9803 12.8739 19.5009 13.5494 19.5009 14.2535H20.0009Z",
    fill: "white",
    mask: "url(#path-3-inside-1_1641_4592)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.80664 12.416C9.4836 11.9849 11.2664 11.9849 12.9434 12.416C13.8794 12.6558 14.4998 13.4173 14.5 14.252V15.3564C14.5 15.5455 14.3192 15.7451 14.041 15.7451H6.70898C6.43076 15.7451 6.25005 15.5455 6.25 15.3564V14.252C6.25021 13.4173 6.87063 12.6558 7.80664 12.416Z",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6245 7.25098C16.7248 7.25109 17.5638 8.04625 17.564 8.96875C17.564 9.89097 16.7199 10.6864 15.6245 10.6865C14.524 10.6865 13.6841 9.89141 13.6841 8.96875C13.6842 8.04618 14.5241 7.25098 15.6245 7.25098Z",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3755 7.25098C11.4708 7.2511 12.3148 8.04663 12.3149 8.96875C12.3149 9.89097 11.4709 10.6864 10.3755 10.6865C9.275 10.6865 8.43506 9.89141 8.43506 8.96875C8.4352 8.04656 9.28005 7.25098 10.3755 7.25098Z",
    stroke: "white",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1641_4592"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 9,
    fill: "white",
    transform: "translate(6 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupinactive);
export default __webpack_public_path__ + "static/media/groupinactive.cb730e997ab0cdc36e2787770ddba764.svg";
export { ForwardRef as ReactComponent };